import React from 'react'

export default function PageNotFound() {
  return (
    <div className='ErrorPageParent'>
      <span className='ErrorText1'>404</span>
      <span className='ErrorText2'>Page Not Found</span>
    </div>
  )
}
